<template>
  <div class="select-upload-mode-wrap">
    <div class="mask" @click="handleHide" />
    <div class="hd">
      <h3>请选择要上传的{{ wallpaperType }}壁纸版本</h3>
    </div>
    <div class="bd">
      <div class="mode-list">
        <div
          class="mode"
          data-mode="pc"
          @click="handleGoUpload"
        >
          <span class="icon icon-pc" />
          <span class="title">电脑{{ wallpaperType }}壁纸</span>
        </div>
        <div
          class="mode"
          data-mode="mobile"
          @click="handleGoUpload"
        >
          <span class="icon icon-mobile" />
          <span class="title">手机{{ wallpaperType }}壁纸</span>
        </div>
        <div
          class="mode double-platform"
          data-mode="all"
          @click="handleGoUpload"
        >
          <span class="icon icon-double-platform" />
          <span class="title">双端{{ wallpaperType }}壁纸</span>
        </div>
      </div>
    </div>
    <div class="ft">
      <p>1.选择上传电脑{{ wallpaperType }}壁纸，作品将上传至<span class="hl">元气壁纸PC客户端</span></p>
      <p>2.选择上传手机{{ wallpaperType }}壁纸，作品将上传至<span class="hl">元气壁纸手机APP</span></p>
      <p>3.选择上传双端{{ wallpaperType }}壁纸，需同时上传电脑及手机版本（作品内容需相同），作品将上传至两个平台。</p>
      <p v-if="type === 'dynamic'">
        4.手机端暂不支持、互动效果、音频响应、时钟和鼠标轨迹
      </p>
      <p v-if="type === 'dynamic'">
        5.动态壁纸中包含的主题组件，仅在PC客户端展示，手机端暂不支持
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectUploadMode',
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    wallpaperType() {
      if (this.type === 'dynamic') return '动态'
      else if (this.type === 'static') return '静态'
      return ''
    },
  },
  methods: {
    handleHide() {
      this.$emit('hide')
    },
    handleGoUpload($event) {
      const platform = $event.currentTarget.dataset.mode
      this.$router.push({
        path: `/creation/${this.type === 'static' ? 'photo' : 'video'}`,
        query: {
          platform,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.select-upload-mode-wrap {
  z-index: 10;
  position: fixed;
  left: 0;
  right: 0;
  top: 50%;
  min-height: 500px;
  margin-top: -250px;
  .mask {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0,0,0,.8);
  }
  .hd {
    position: relative;
    margin-bottom: 70px;
    h3 {
      text-align: center;
      font-size: 18px;
      color: #fff;
    }
  }
  .bd {
    position: relative;
  }
  .mode-list {
    display: flex;
    justify-content: center;
    .mode {
      position: relative;
      width: 270px;
      height: 270px;
      margin: 0 40px;
      background: #FFFFFF;
      border-radius: 20px;
      cursor: pointer;
      &:hover {
        .icon {
          background: #F4C000;
          mask-size: 100% 100%;
        }
        .icon-pc {
          mask: url('~@/assets/images/upload/icon-pc.png') no-repeat;
        }
        .icon-mobile {
          mask: url('~@/assets/images/upload/icon-mobile.png') no-repeat;
        }
        .icon-double-platform {
          mask: url('~@/assets/images/upload/icon-double-platform.png') no-repeat;
        }
        .title {
          color: #F4C000;
        }
      }
      .icon {
        display: block;
        margin: 60px auto 0;
      }
      .title {
        position: absolute;
        left: 0;
        right: 0;
        top: 205px;
        text-align: center;
        font-size: 14px;
        color: #333;
      }
    }
    .double-platform {
      &::before {
        content: '推荐';
        position: absolute;
        right: 0;
        top: 0;
        width: 60px;
        height: 60px;
        line-height: 35px;
        text-indent: 28px;
        font-size: 12px;
        background: url('~@/assets/images/upload/icon-mode-tips-bg.png') 0 0 no-repeat;
        color: #333;
      }
    }
  }
  .ft {
    position: relative;
    padding-top: 70px;
    p {
      line-height: 2;
      text-align: center;
      color: #A5A5AE;
    }
  }
  .hl {
    color: #F4C000;
  }
  .icon-pc {
    display: inline-block;
    width: 130px;
    height: 102px;
    background: url('~@/assets/images/upload/icon-pc.png') 0 0 no-repeat;
  }
  .icon-mobile {
    display: inline-block;
    width: 61px;
    height: 102px;
    background: url('~@/assets/images/upload/icon-mobile.png') 0 0 no-repeat;
  }
  .icon-double-platform {
    display: inline-block;
    width: 156px;
    height: 119px;
    background: url('~@/assets/images/upload/icon-double-platform.png') 0 0 no-repeat;
  }
}
</style>
